/**
 * Shared animation coordination between SecurityVisual and CodeInput.
 *
 * Provides triggerUnlock(), triggerDeny() and clearCodeInput() methods that
 * keep both child components in sync with the same timing and behaviour.
 *
 * Requirements for the consuming component:
 *  - Must have a `<security-visual ref="securityVisual" />` in the template
 *  - Must have a `<code-input ref="codeInput" />` in the template
 */
export default {
    data() {
        return {
            isUnlocking: false,
            isUnlocked: false,
        };
    },

    methods: {
        /**
         * Play the unlock → check mark success animation on both the security
         * visual (lock icon) and the code input fields.
         */
        triggerUnlock() {
            this.$refs.codeInput?.showSuccess();
            this.$refs.securityVisual?.triggerUnlock();

            this.isUnlocking = true;
            setTimeout(() => {
                this.isUnlocking = false;
                this.isUnlocked = true;
            }, 400);
        },

        /**
         * Play the deny/error animation on both the security visual (shake +
         * red lock) and the code input fields (shake + red border).
         */
        triggerDeny() {
            this.$refs.codeInput?.showError();
            this.$refs.securityVisual?.triggerDeny();
        },

        /**
         * Clear the code input digits after a short delay so the error
         * animation has time to play before the fields are emptied.
         */
        clearCodeInput() {
            setTimeout(() => {
                this.$refs.codeInput?.clear();
            }, 400);
        },
    },
};
